import { useMutation, useQuery } from '@apollo/client'
import React, { useEffect, useState } from 'react'
import {
  DELETE_ROUTE_POINT,
  GET_ALL_ROUTES_POINTS,
} from '../../../../../graphql/Catalog/Trucks/Routes/routesPoints'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import LayoutTable from '../../../../Global/LayoutTable'
import DetailsRoute from './DetailsRoute'
import ProgressBarStatus from '../../../../Global/ProgressBarStatus'
import { categorModule } from '../../WaterTruckRequest/WaterTruckRequest'
import { useLoading } from '../../../../../LoadingOverlay/LoadingOverlayContext'

const RoutesPoints = ({
  routeId,
  refModal,
  setCloseModal,
  detailsRoute,
  routeComplete,
  setWaterRequestId,
  setFetchsData,
  setAddRequestToRoute,
  routeIsOnRoute,
  //DETAILS FOR ROUTE POINT
  setDetailsRoutePoint,
  setIsLastPoint,
  invoiceRoutePoint,
  refetchPrincipal,
}) => {
  const [infoRequest, setInfoRequest] = useState([])

  const [dataTable, setDataTable] = useState([])
  const [total, setTotal] = useState(0)
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
    routeId: +routeId,
  })

  const { showLoading, hideLoading } = useLoading()

  const { loading, error, data, refetch } = useQuery(GET_ALL_ROUTES_POINTS, {
    variables: {
      limit: pagePagination.limit,
      offset: pagePagination.offset,
      searchQuery: pagePagination.searchQuery,
      routeId: pagePagination.routeId,
    },
    fetchPolicy: 'no-cache',
    skip: detailsRoute,
  })

  const [deletePoint] = useMutation(DELETE_ROUTE_POINT)

  useEffect(() => {
    try {
      if (detailsRoute) return
      if (loading) return
      if (error) throw error

      if (!data) throw new Error('No se encontraron datos')

      const { getAllRoutePoints } = data
      console.log(data)

      if (getAllRoutePoints.rows.length === 0) return setDataTable([])

      if (detailsRoute) return setInfoRequest(getAllRoutePoints.rows)

      const infoPoint = getAllRoutePoints.rows.map((point) => {
        return {
          id: point.id,
          folio: point.RoutePointsToWaterTruckRequest.folio,
          extemporaneo: point.RoutePointsToWaterTruckRequest.is_extemporaneous
            ? 'Si'
            : 'No',
          Garza: point.RoutePointsToWaterStation.name,
          estatus: (
            <ProgressBarStatus
              category={categorModule}
              status={
                point.RoutePointsToWaterTruckRequest.StatusOfWaterTruckRequest
              }
            />
          ),
          inicio: point.RoutePointsToWaterStation.address,
          destino:
            point.RoutePointsToWaterTruckRequest.AddressOfWaterTruckRequest
              .address_full,
          volumen: point.RoutePointsToWaterTruckRequest.volume + ' m3',
          route_point__omit: point,
        }
      })

      setDataTable(infoPoint)
      setTotal(getAllRoutePoints.count)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loading, error, data])

  const handelEditRequest = (id, row) => {
    setIsLastPoint(total === 1 ? true : false)
    setWaterRequestId(row)
    setFetchsData((prev) => ({
      ...prev,
      refetchRoutesPoints: refetch,
    }))
  }

  const handleAddRequestToRoute = () => {
    setAddRequestToRoute(true)
    setFetchsData((prev) => ({
      ...prev,
      refetchRoutesPoints: refetch,
    }))
  }

  const onDelete = async (id) => {
    let finish = false
    try {
      const response = await toastSweetAlert({
        mode: 'modalConfirmCancel',
        title: 'Eliminar punto',
        message: `Vas a remover este punto de la ruta ¿Desea continuar?`,
      })
      if (response.isConfirmed) {
        showLoading()
        const result = await deletePoint({
          variables: { id },
        })

        if (result.data.deleteRoutePoint) {
          finish = true
          await refetch({
            variables: {
              limit: pagePagination.limit,
              offset: pagePagination.offset,
              searchQuery: pagePagination.searchQuery,
              routeId: pagePagination.routeId,
            },
            skip: detailsRoute,
          })
          return await refetchPrincipal()
        }
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
      if (finish) {
        return await toastSweetAlert({
          mode: 'ok',
          message: 'Punto removido',
        })
      }
    }
  }

  return (
    <>
      {!detailsRoute ? (
        <>
          <LayoutTable
            hideId
            hideAddNew
            withCard={false}
            data={dataTable}
            totalCount={total}
            loadingData={loading}
            pagePagination={pagePagination}
            setPagePagination={setPagePagination}
            actionBtnDetails={(id) => setDetailsRoutePoint(id)}
            exportImportButton={false}
            hideBtnDelete={routeIsOnRoute}
            hideBtnEdit={routeIsOnRoute === 2}
            actionBtnEdit={(id, row) => handelEditRequest(id, row)}
            showAddNewButton={!routeIsOnRoute}
            handleAddNewButton={() => handleAddRequestToRoute()}
            handleAddNewButtonTxt="Agregar solicitudes a la ruta"
            // refetchFunctionQueries={async () => refetch()}
            // gql={DELETE_ROUTE_POINT}
            actionBtnErase={(e) => {
              onDelete(e)
            }}
            // requery={refetch}
            noDataComponent='Esta ruta no contiene solicitudes de pipas, por favor agrega rutas en el botón "Agregar solicitudes a la ruta"'
          />
        </>
      ) : (
        <>{infoRequest && <DetailsRoute routePointInfo={routeComplete} />}</>
      )}
    </>
  )
}

export default RoutesPoints
